// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function RocketIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M19 28a1 1 0 0 1-1 1h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1Zm-3-14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm11.953 5.479-1.546 6.954a2.001 2.001 0 0 1-3.188 1.138L19.814 25h-7.625L8.78 27.571a2 2 0 0 1-3.189-1.139L4.047 19.48a2.011 2.011 0 0 1 .415-1.714l3.57-4.283c.12-1.573.482-3.12 1.072-4.583 1.612-4.043 4.5-6.579 5.671-7.481a2 2 0 0 1 2.45 0c1.167.902 4.059 3.438 5.671 7.48.59 1.465.952 3.01 1.072 4.585l3.57 4.282a2.011 2.011 0 0 1 .415 1.714ZM12.429 23h7.142c2.64-4.692 3.134-9.185 1.468-13.36C19.569 5.955 16.81 3.625 16 3c-.814.625-3.571 2.955-5.041 6.64-1.664 4.175-1.17 8.668 1.47 13.36Zm-1.875.731c-1.346-2.446-2.163-4.85-2.45-7.211L6 19.045 7.545 26l.022-.016 2.987-2.253ZM26 19.045l-2.104-2.525c-.285 2.357-1.1 4.76-2.445 7.211l2.982 2.25.022.016L26 19.045Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
